<div class="ButtonContainer">
	<button type="button" [attr.aria-label]="(ariaDescription) | translate" *ngIf="isEnabled" class="ButtonContainer__button" (click)="buttonClicked()">{{text | translate}}</button>
	<button type="button" [attr.aria-label]="(ariaDescription) | translate" *ngIf="!isEnabled" class="ButtonContainer__button ButtonContainer__button--disabled" disabled>{{text | translate}}</button>
</div>
